import React from 'react';

const PolitykaPrywatnosci = () => {
  return (
    <main className="privacy-policy">
      <h1>Polityka Prywatności</h1>
      <p><em>Ostatnia aktualizacja: 03.05.2025</em></p>

      <section>
        <h2>1. Informacje ogólne</h2>
        <p>
          Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych
          przekazanych przez Użytkowników w związku z korzystaniem ze strony internetowej
          <strong> www.kompland.com.pl</strong>.
        </p>
      </section>

      <section>
        <h2>2. Administrator danych osobowych</h2>
        <p>
          Administratorem danych osobowych jest:<br />
          <strong>KompLand Sp. z o.o.</strong><br />
          ul. Przykładowa 12, 00-000 Miasto<br />
          NIP: 123-456-78-90<br />
          E-mail: <a href="mailto:biuro@kompland.com.pl">biuro@kompland.com.pl</a><br />
          Tel: +48 601 123 456
        </p>
      </section>

      <section>
        <h2>3. Zakres zbieranych danych</h2>
        <p>
          Zbieramy dane osobowe niezbędne do:<br />
          – kontaktu z klientem,<br />
          – realizacji usług informatycznych,<br />
          – obsługi zgłoszeń (formularze kontaktowe, helpdesk),<br />
          – zapewnienia bezpieczeństwa i funkcjonalności strony.
        </p>
        <p>Dane mogą obejmować: imię i nazwisko, e-mail, telefon, adres IP.</p>
      </section>

      <section>
        <h2>4. Cele i podstawy prawne przetwarzania</h2>
        <p>Dane przetwarzamy na podstawie:</p>
        <ul>
          <li>art. 6 ust. 1 lit. a RODO – zgoda użytkownika,</li>
          <li>art. 6 ust. 1 lit. b RODO – wykonanie umowy lub działania przedumowne,</li>
          <li>art. 6 ust. 1 lit. f RODO – uzasadniony interes administratora.</li>
        </ul>
      </section>

      <section>
        <h2>5. Przechowywanie danych</h2>
        <p>
          Dane przechowujemy przez czas:
          <ul>
            <li>realizacji celu przetwarzania,</li>
            <li>wymagany przepisami prawa,</li>
            <li>do momentu cofnięcia zgody (jeśli dotyczy).</li>
          </ul>
        </p>
      </section>

      <section>
        <h2>6. Odbiorcy danych</h2>
        <p>Dane mogą być przekazywane:</p>
        <ul>
          <li>dostawcom usług IT i hostingu,</li>
          <li>firmom wspierającym obsługę techniczną,</li>
          <li>organom państwowym, gdy wymaga tego prawo.</li>
        </ul>
      </section>

      <section>
        <h2>7. Prawa użytkownika</h2>
        <p>Masz prawo do:</p>
        <ul>
          <li>dostępu do danych,</li>
          <li>ich poprawiania, usuwania, ograniczenia, przenoszenia,</li>
          <li>sprzeciwu wobec przetwarzania,</li>
          <li>wycofania zgody w dowolnym momencie.</li>
        </ul>
        <p>Kontakt w sprawie danych: <a href="mailto:iod@kompland.com.pl">iod@kompland.com.pl</a></p>
      </section>

      <section>
        <h2>8. Pliki cookies</h2>
        <p>
          Serwis używa plików cookies do:
          <ul>
            <li>celów statystycznych i analitycznych,</li>
            <li>zapewnienia funkcjonalności,</li>
            <li>zapamiętywania preferencji użytkownika.</li>
          </ul>
        </p>
        <p>
          Możesz zmienić ustawienia cookies w przeglądarce. Szczegóły znajdziesz w naszej
          <a href="/polityka-cookies"> Polityce cookies</a>.
        </p>
      </section>

      <section>
        <h2>9. Zabezpieczenia danych</h2>
        <p>
          Stosujemy odpowiednie środki techniczne i organizacyjne, by chronić dane osobowe przed
          dostępem osób nieupoważnionych.
        </p>
      </section>

      <section>
        <h2>10. Zmiany w polityce prywatności</h2>
        <p>
          Zastrzegamy sobie prawo do wprowadzania zmian. Aktualna wersja będzie zawsze dostępna na
          tej stronie.
        </p>
      </section>
    </main>
  );
};

export default PolitykaPrywatnosci;
